import { Component, computed, inject, model } from '@angular/core';
import { ModalService } from '../../../core/services/modal/modal.service';

@Component({
    selector: 'app-modal',
    imports: [],
    templateUrl: './modal.component.html',
    styleUrl: './modal.component.css'
})
export class ModalComponent {
  private modalService = inject(ModalService);

  _modalItems = model<any>();

  isVisible = computed(
    () => this.modalService.modalVisibility()
  );

  close() {
    this.modalService.closeModal();
  }

  cancel() {
    this.close();
  }
}
